import { FC } from "react";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import { AIIcon } from "@/assets/icons/app-related/AIIcon";
import { CopyIconButton } from "@/components/common/CopyIconButton";
import { getTextFromHTML } from "@/components/utils/helpers/slack-formatters/getTextFromHTML";

interface AiKubernetesRecommendationDescriptionTooltip {
  description: string;
}

export const AiKubernetesRecommendationDescriptionTooltip: FC<
  AiKubernetesRecommendationDescriptionTooltip
> = ({ description }) => {
  const descriptionText = getTextFromHTML(description);

  return (
    <Stack
      p={1.5}
      spacing={1}
      borderRadius={2}
      overflow="hidden"
      sx={descriptionStyles}
    >
      <Stack spacing={1} direction="row" alignItems="center">
        <AIIcon />
        <Typography variant="body1" fontWeight="bold">
          Description
        </Typography>
        <CopyIconButton
          data={descriptionText}
          TooltipProps={{ placement: "top" }}
        />
      </Stack>
      <Typography
        variant="subtitle2"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </Stack>
  );
};

const descriptionStyles = {
  background: "linear-gradient(145.9deg, #EAEDFF 0%, #F3EDFF 99.94%)",
};
